import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';

export default function useIsMobile(): boolean {
  const breakpoint = useBreakpoint();

  const isMobile =
    // @ts-ignore
    (navigator.userAgentData?.mobile ?? window.matchMedia('(pointer: coarse)').matches) || breakpoint === 'mobile';

  return isMobile;
}
